module.exports = __webpack_public_path__ + "img/gif-jz.f5bd27db.gif";